import React from 'react'
import { PropsWithChildrenRequired } from '../../../types/PropsWithChildrenRequired'

type Props = {
    imgSrc: string
    caption: string
}

// images from https://undraw.co/

function NoRecords({
    imgSrc,
    caption,
    children,
}: PropsWithChildrenRequired<Props>): React.JSX.Element {
    return (
        <div className="flex justify-center mt-24">
            <div className="text-center">
                <img src={imgSrc} className="w-1/2 mx-auto" />
                <p className="mt-4 text-gray-700 text-xl">{caption}</p>
                {children}
            </div>
        </div>
    )
}

export default NoRecords
